import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  AfterViewInit,
} from "@angular/core";

import { CommonService } from "src/app/services/common.service";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { BaseComponent } from "../pages/base.component";
import * as Chart from "chart.js";
import * as Highcharts from "highcharts/highmaps";
import HC_map from "highcharts/modules/map";

HC_map(Highcharts);

@Component({
  selector: "app-super-admin-dashboard",
  templateUrl: "./super-admin-dashboard.component.html",
  styleUrls: ["./super-admin-dashboard.component.css"],
})
export class SuperAdminDashboardComponent extends BaseComponent implements OnInit, AfterViewInit {

  @ViewChild("mapContainer", { static: false })
  mapContainer!: ElementRef<HTMLDivElement>;

  @ViewChild('subMapContainer', { static: false })
  subMapContainer!: ElementRef<HTMLDivElement>;

  selectedCounty: any = '';
  selectedCountyId: any = 0;


  donutChart!: Chart;
  subCntyDonutChart!: Chart;
  breakdownbarChart!: Chart;
  institutionsbarChart!: Chart;
  topCountysLst: any[] = [];
  institutionsList: any = [];
  countyChatsList: any = "";
  barChart!: Chart;
  barChartmonth!: Chart;
  dbDetails: any = "";
  tooltipVisible = false;
  tooltipX = 0;
  tooltipY = 0;
  tooltipTitle = "";
  lineChart!: Chart;
  countyDetails: any = "";
  countiesList: any[] = [];
  subCountyList: any[] = [];
  selectedSubCountyId: any = 0;

  constructor(
    CommonService: CommonService,
    toastr: ToastrService,
    private route: Router,
    private active: ActivatedRoute
  ) {
    super(CommonService, toastr);
  }


  ngOnInit(): void {
    this.GridList();
    this.LoadTopCountysList(),
      this.LoadCounties();
    // this.loadKenyaMap(),
    //  this.LoadChartsData();
    // this.LoadCountyDetails();
    // this.LoadTopSubCountysList();
    // this.LoadInstitutions(),
  }

  ngAfterViewInit(): void {

  }

  LoadCounties() {
    this.countiesList = [];
    this.activeSpinner();
    this.CommonService.postCall("Dashboard/GetCountiesInstitutionsCount", {
      TENANTCODE: this.TenantCode,
    }).subscribe(
      (res: any) => {
        // if(res?.status) {
        this.countiesList = res;
        if (this.countiesList.length > 0) {
          this.loadMap();
        }
        // } else {
        //   this.toastr.error(res?.message);
        // }
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
        this.toastr.error(e?.message ?? e.error?.message);
      }
    );
  }

  async loadMap() {

    if (!this.countiesList || this.countiesList.length === 0) return;

    const topology = await fetch('assets/Maps/ke-counties.topo.json')
      .then(res => res.json());

    const mapFeatures = Highcharts.geojson(topology);

    const mapData = mapFeatures.map((f: any) => {

      const apiCounty = this.countiesList.find((c: any) =>
        c.COUNTIES_NAME?.trim().toLowerCase().replace(/\s+/g, '') ===
        f.properties.NAME_1?.trim().toLowerCase()
      );

      return {
        name: f.properties.NAME_1,   // 🔥 join key
        value: apiCounty ? apiCounty.TOTAL_INSTITUTIONS : 0,
        countyId: apiCounty ? apiCounty.COUNTIES_ID : null
      };
    });

    const maxValue = Math.max(...mapData.map(d => d.value), 1);

    Highcharts.mapChart(this.mapContainer.nativeElement, {

      chart: { map: topology },
      title: { text: '' },
      credits: { enabled: false },
      mapNavigation: { enabled: true },
      legend: { enabled: false },
      colorAxis: {
        min: 0,
        max: maxValue,
        stops: [
          [0, '#fee2e2'],   // very light red
          [0.5, '#fca5a5'], // medium red
          [1, '#b91c1c']    // 🔥 MAX = dark red
        ],
        showInLegend: false
      },

      series: [{
        type: 'map',
        data: mapData,

        joinBy: ['NAME_1', 'name'],   // 🔥 MATCH USING COUNTY NAME

        borderColor: '#000',
        borderWidth: 1,

        states: {
          hover: { brightness: -0.3 }
        },

        dataLabels: {
          enabled: true,
          format: '{point.name}',
          color: '#000'
        },

        tooltip: {
          headerFormat: '',
          pointFormat: '<b>{point.name}</b><br/>Institutions: {point.value}'
        },
        point: {
          events: {
            click: (e: any) => {
              console.log('County:', e.point.name);
              console.log('County ID:', e.point.countyId);
              this.selectedCounty = '';
              this.selectedCountyId = '';
              setTimeout(() => {
                this.selectedCounty = e.point.name;
                this.selectedCountyId = e.point.countyId;
                this.LoadSubCounties(this.selectedCountyId);
                this.LoadChartsData(this.selectedCountyId);
                this.LoadTopSubCountysList(this.selectedCountyId);
              }, 200);
            }
          }
        }

      }]
    });
  }

  async loadSubCountyMap(countyName: string) {

    const county = this.countiesList.find(c =>
      c.COUNTIES_NAME?.trim().toLowerCase().replace(/\s+/g, '') === countyName?.trim().toLowerCase()
    );
    if (!county) return;
    const countyKey = county.COUNTIES_NAME
      .replace(/’|'/g, '')
      .replace(/ /g, '_');

    const filePath = `assets/Maps/subcounties/${countyKey}.geo.json`;

    const geojson = await fetch(filePath).then(res => {
      if (!res.ok) throw new Error('Sub-county map not found');
      return res.json();
    });

    const mapFeatures = Highcharts.geojson(geojson);

    const mapData = mapFeatures.map((f: any) => {

      const apiSub = this.subCountyList.find((s: any) =>
        s.SUB_COUNTIES_NAME?.trim().toLowerCase().replace(/\s+/g, '') ===
        f.properties.NAME_2?.trim().toLowerCase()
      );

      return {
        name: f.properties.NAME_2,
        value: apiSub ? apiSub.TOTAL_INSTITUTIONS : 0,
        subCountyId: apiSub ? apiSub.SUB_COUNTIES_ID : null
      };
    });

    const maxValue = Math.max(...mapData.map(d => d.value), 1);

    Highcharts.mapChart(this.subMapContainer.nativeElement, {

      chart: { map: geojson },
      title: { text: '' },
      credits: { enabled: false },
      legend: { enabled: false },
      colorAxis: {
        min: 0,
        max: maxValue,
        stops: [
          [0, '#fee2e2'],   // very light red
          [0.5, '#fca5a5'], // medium red
          [1, '#b91c1c']    // 🔥 MAX = dark red
        ],
        showInLegend: false
      },

      series: [{
        type: 'map',
        data: mapData,
        joinBy: ['NAME_2', 'name'],   // 🔥 required

        borderColor: '#000',
        borderWidth: 1,

        enableMouseTracking: true,

        states: {
          hover: { brightness: -0.3 }
        },

        dataLabels: {
          enabled: true,
          format: '{point.name}',
          color: '#000'
        },

        tooltip: {
          headerFormat: '',
          pointFormat: '<b>{point.name}</b><br/>Institutions: {point.value}'
        },

        point: {
          events: {
            click: (e: any) => {
              console.log('SubCounty Name:', e.point.name);
              console.log('SubCounty DB ID:', e.point.subCountyId);

              this.selectedSubCountyId = e.point.subCountyId;
              this.LoadCountyDetails(this.selectedSubCountyId);
              this.LoadInstitutions()
            }
          }
        }
      }]
    });
  }

  LoadSubCounties(COUNTIE_ID: any = '') {
    this.subCountyList = [];
    this.activeSpinner();
    this.CommonService.postCall("Dashboard/GetSubCountiesInstitutionsCount", {
      TENANTCODE: this.TenantCode,
      COUNTIE_ID: COUNTIE_ID
    }).subscribe(
      (res: any) => {
        // if(res?.status) {
        this.subCountyList = res;
        if (this.subCountyList.length > 0) {
          this.loadSubCountyMap(this.selectedCounty);
        }
        // } else {
        //   this.toastr.error(res?.message);
        // }
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
        this.toastr.error(e?.message ?? e.error?.message);
      }
    );
  }

  GridList() {
    this.dbDetails = "";
    this.activeSpinner();
    this.CommonService.postCall("Dashboard/LoadSuperAdminDashboard", {
      TENANTCODE: this.TenantCode,
    }).subscribe(
      (res: any) => {
        // if(res?.status) {
        this.dbDetails = res;
        // } else {
        //   this.toastr.error(res?.message);
        // }
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
        this.toastr.error(e?.message ?? e.error?.message);
      }
    );
  }

  LoadInstitutions() {
    this.institutionsList = [];
    this.activeSpinner();
    this.CommonService.postCall("Dashboard/LoadSuperAdminDashboardInstitutionListBySubCounties", {
      TENANTCODE: this.TenantCode,
      COUNTIE_ID: +this.selectedCountyId,
      SUB_COUNTIE_ID: +this.selectedSubCountyId
    }).subscribe(
      (res: any) => {
        // if(res?.status) {
        this.institutionsList = res;
        // } else {
        //   this.toastr.error(res?.message);
        // }
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
        this.toastr.error(e?.message ?? e.error?.message);
      }
    );
  }

  LoadCountyDetails(subCounty) {
    this.countyDetails = "";
    this.activeSpinner();
    let payLoad: any = {
      TENANTCODE: this.TenantCode,
      COUNTIE_ID: this.selectedCountyId,
      SUB_COUNTIE_ID: subCounty,
    };
    this.CommonService.postCall(
      "Dashboard/LoadSuperAdminDashboardBySubCounties",
      payLoad
    ).subscribe(
      (res: any) => {
        // if(res?.status) {
        this.countyDetails = res?.count;
        this.LoadSubCountyDonutChart(res?.donut);
        // } else {
        //   this.toastr.error(res?.message);
        // }
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
        this.toastr.error("No Institutions Available in the Selected County or Subcounty");
      }
    );
  }

  LoadTopSubCountysList(COUNTIE_ID) {
    // this.topCountysLst = [];
    let topSubCountys: any = "";
    this.activeSpinner();
    let payLoad: any = { TENANTCODE: this.TenantCode, COUNTIE_ID: COUNTIE_ID };
    this.CommonService.postCall(
      "Dashboard/LoadSuperAdminDashboardInstitutionsStudentsBySubCounties",
      payLoad
    ).subscribe(
      (res: any) => {
        // if(res?.status) {
        topSubCountys = res;
        this.LoadBreakDownBarChart(topSubCountys?.students),
          this.LoadSCBarChart(topSubCountys?.institutions),
          // } else {
          //   this.toastr.error(res?.message);
          // }
          this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
        this.toastr.error(e?.message ?? e.error?.message);
      }
    );
  }

  LoadTopCountysList() {
    this.topCountysLst = [];
    this.activeSpinner();
    this.CommonService.postCall("Dashboard/GetTopCountiesByInstitutions", {
      TENANTCODE: this.TenantCode,
    }).subscribe(
      (res: any) => {
        // if(res?.status) {
        this.topCountysLst = res;
        this.loadBarChart(this.topCountysLst);
        // } else {
        //   this.toastr.error(res?.message);
        // }
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
        this.toastr.error(e?.message ?? e.error?.message);
      }
    );
  }

  LoadChartsData(COUNTIE_ID: any = 0) {
    this.countyChatsList = "";
    this.activeSpinner();
    let payLoad: any = {
      TENANTCODE: this.TenantCode,
      SELECTED_YEAR: 2026,
      COUNTIE_ID: COUNTIE_ID,
    };
    this.CommonService.postCall(
      "Dashboard/LoadSuperAdminDashboardDataByCountiesId",
      payLoad
    ).subscribe(
      (res: any) => {
        // if(res?.status) {
        this.countyChatsList = res;
        this.loadLineChart(this.countyChatsList?.graph);
        this.loadMonthWiseBarChart(this.countyChatsList?.bar);
        this.loadDonutChart(this.countyChatsList?.donut);
        // } else {
        //   this.toastr.error(res?.message);
        // }
        this.LoadCountyDetails(0);
        this.LoadInstitutions();
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
        this.toastr.error(e?.message ?? e.error?.message);
      }
    );
  }

  loadLineChart(data: any[]): void {
    // map API data
    const labels = data.map((x) => x.MONTH_NAME);
    const values = data.map((x) => x.INSTITUTE_COUNT);

    const canvas = document.getElementById("lineChart") as HTMLCanvasElement;

    if (this.lineChart) {
      this.lineChart.destroy();
    }

    this.lineChart = new Chart(canvas, {
      type: "line",
      data: {
        labels,
        datasets: [
          {
            label: "Institutes",
            data: values,
            borderColor: "#2f80ed",
            backgroundColor: "rgba(47,128,237,0.1)",
            fill: true,
            // tension: 0.4,
            pointRadius: 4,
            pointHoverRadius: 6,
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: true,
          },
        },
        // scales: {
        //   y: {
        //     beginAtZero: true
        //   }
        // }
      },
    });
  }

  loadBarChart(data: any[]): void {
    const labels = data.map((x) => x.COUNTIES_NAME);
    const values = data.map((x) => x.TOTAL_INSTITUTIONS);
    const maxVal = Math.max(...data.map(x => x.TOTAL_INSTITUTIONS));

    const canvas = document.getElementById("barChart") as HTMLCanvasElement;

    if (this.barChart) {
      this.barChart.destroy();
    }

    this.barChart = new Chart(canvas, {
      type: "bar",
      data: {
        labels,
        datasets: [
          {
            label: "Institutions",
            data: values,
            // barThickness: 35, // ✅ no colors applied
            backgroundColor: "#228B22", // ✅ Green color
            borderColor: "#0D47A1",
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: "top",
          },
          tooltip: {
            enabled: true,
          },
        },
        scales: {
          // y: {
          //   beginAtZero: true
          // }
          yAxes: [
            {
              ticks: {
                max: Math.ceil(maxVal / 10) * 10,
                beginAtZero: false,
                stepSize: 10,     // your calculated step value
                precision: 0
              },
              gridLines: {
                drawBorder: false
              }
            }
          ],
        },
      },
    });
  }

  loadStackedBarChart(): void {
    const canvas = document.getElementById("stackedBar") as HTMLCanvasElement;

    new Chart(canvas, {
      type: "bar",
      data: {
        labels: ["Jan", "Feb", "Mar", "Apr", "May"],
        datasets: [
          {
            label: "Basic Education Schools",
            data: [40, 55, 60, 70, 65],
            backgroundColor: "#42A5F5",
          },
          {
            label: "TVET College",
            data: [20, 25, 30, 20, 25],
            backgroundColor: "#FFA726",
          },
          {
            label: "Universities",
            data: [10, 15, 12, 8, 10],
            backgroundColor: "#EF5350",
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: "top",
          },
          tooltip: {
            mode: "index",
            intersect: false,
          },
        },
        // scales: {
        //   x: {
        //     stacked: true,
        //     grid: {
        //       display: false
        //     }
        //   },
        //   y: {
        //     stacked: true,
        //     beginAtZero: true
        //   }
        // }
      },
    });
  }

  loadMonthWiseBarChart(data: any[]): void {
    const labels = data.map((x) => x.MONTH);
    const basic = data.map((x) => x.BASIC);
    const tvet = data.map((x) => x.TVET);
    const uni = data.map((x) => x.UNI);

    const canvas = document.getElementById(
      "barChartmonth"
    ) as HTMLCanvasElement;

    if (this.barChartmonth) {
      this.barChartmonth.destroy();
    }

    this.barChartmonth = new Chart(canvas, {
      type: "bar",
      data: {
        labels,
        datasets: [
          {
            label: "Basic Education Schools",
            data: basic,
            backgroundColor: "#42A5F5",
          },
          {
            label: "TVET College",
            data: tvet,
            backgroundColor: "#FFA726",
          },
          {
            label: "Universities",
            data: uni,
            backgroundColor: "#EF5350",
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: "top",
          },
          tooltip: {
            mode: "index",
            intersect: false,
          },
        },
        // scales: {
        //   x: {
        //     stacked: false   // 👈 IMPORTANT (grouped bars)
        //   },
        //   y: {
        //     beginAtZero: true
        //   }
        // }
      },
    });
  }

  LoadBreakDownBarChart(data: any[]): void {
    const labels = data.map((x) => x.SUB_COUNTIES_NAME);
    const values = data.map((x) => x.TOTAL_STUDENTS);
    const maxVal = Math.max(...data.map(x => x.TOTAL_STUDENTS));
    const canvas = document.getElementById(
      "breakdownbarChart"
    ) as HTMLCanvasElement;

    if (this.breakdownbarChart) {
      this.breakdownbarChart.destroy();
    }

    this.breakdownbarChart = new Chart(canvas, {
      type: "bar",
      data: {
        labels,
        datasets: [
          {
            label: "Students",
            data: values,
            barThickness: 35, // ✅ no colors applied
            backgroundColor: "#228B22", // ✅ BLUE color
            borderColor: "#0D47A1",
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'top'
          },
          tooltip: {
            enabled: true
          }
        },
        scales: {
          yAxes: [
            {
              ticks: {
                max: Math.ceil(maxVal / 10) * 10,
                beginAtZero: false,
                stepSize: 10,     // your calculated step value
                precision: 0
              },
              gridLines: {
                drawBorder: false
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                autoSkip: false,
                maxRotation: 45,
                minRotation: 45
              }
            }
          ]
        }

      }

    });
  }

  LoadSCBarChart(data: any[]): void {
    const labels = data.map((x) => x.SUB_COUNTIES_NAME);
    const values = data.map((x) => x.TOTAL_INSTITUTIONS);
    const maxVal = Math.max(...data.map(x => x.TOTAL_INSTITUTIONS));
    const canvas = document.getElementById(
      "institutionsbarChart"
    ) as HTMLCanvasElement;

    if (this.institutionsbarChart) {
      this.institutionsbarChart.destroy();
    }

    this.institutionsbarChart = new Chart(canvas, {
      type: "bar",
      data: {
        labels,
        datasets: [
          {
            label: "Institutions",
            data: values,
            barThickness: 35, // ✅ no colors applied
            backgroundColor: "#228B22", // ✅ BLUE color
            borderColor: "#0D47A1",
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: "top",
          },
          tooltip: {
            enabled: true,
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                max: Math.ceil(maxVal / 10) * 10,
                beginAtZero: false,
                stepSize: 10,     // your calculated step value
                precision: 0
              },
              gridLines: {
                drawBorder: false
              }
            }
          ],
        }

      },
    });
  }

  loadDonutChart(data: any[]): void {
    const labels = data.map((x) => x.INSTITUTION_NAME);
    const values = data.map((x) => x.INSTITUTE_COUNT);

    const canvas = document.getElementById("donutChart") as HTMLCanvasElement;

    // destroy old chart
    if (this.donutChart) {
      this.donutChart.destroy();
    }

    this.donutChart = new Chart(canvas, {
      type: "doughnut",
      data: {
        labels,
        datasets: [
          {
            label: "Institutions",
            data: values,
            // single professional color set
            backgroundColor: ["#1976D2", "#90CAF9", "#BBDEFB"],
            borderWidth: 0,
          },
        ],
      },
      options: {
        responsive: true,
        // cutout: '70%',
        plugins: {
          legend: {
            position: "bottom",
          },
          tooltip: {
            callbacks: {
              label: (ctx) => `${ctx.label}: ${ctx.parsed}`,
            },
          },
        },
      },
    });
  }

  LoadSubCountyDonutChart(data: any[]): void {
    const labels = data.map((x) => x.INSTITUTION_NAME);
    const values = data.map((x) => x.INSTITUTE_COUNT);

    const canvas = document.getElementById(
      "subCountyDonutChart"
    ) as HTMLCanvasElement;

    // destroy old chart
    if (this.subCntyDonutChart) {
      this.subCntyDonutChart.destroy();
    }

    this.subCntyDonutChart = new Chart(canvas, {
      type: "doughnut",
      data: {
        labels,
        datasets: [
          {
            label: "Institutions",
            data: values,
            // single professional color set
            backgroundColor: ["#1976D2", "#90CAF9", "#BBDEFB"],
            borderWidth: 0,
          },
        ],
      },
      options: {
        responsive: true,
        // cutout: '70%',
        plugins: {
          legend: {
            position: "bottom",
          },
          tooltip: {
            callbacks: {
              label: (ctx) => `${ctx.label}: ${ctx.parsed}`,
            },
          },
        },
      },
    });
  }

}
